import {
  put, takeEvery, select,
} from 'redux-saga/effects';
import {
  ACT_INSTANCES_FETCH_PRODUCTS_INIT_ACTION,
  ACT_INSTANCES_GET_PRODUCT_INIT_ACTION,
  ACT_INSTANCES_ADD_PRODUCT_INIT_ACTION,
  ACT_INSTANCES_DELETE_PRODUCT_INIT_ACTION,
  ACT_INSTANCES_UPDATE_PRODUCTS_FILTERS,
} from '../../constants/actions';
import {
  addProductSuccessAction,
  deleteProductSuccessAction,
  fetchProductsSuccessAction,
  getProductSuccessAction,
} from '../../actions/instances/products';
import Api from '../../services/Api';

function* fetchProducts() {
  const { filters } = yield select(state => state.products);
  let query = '';
  if (filters.dynasties.length > 0) {
    query += filters.dynasties.map(dynasty => `&dynasties_ids[]=${dynasty}`);
  }
  if (filters.types.length > 0) {
    query += filters.types.map(type => `&types_ids[]=${type}`);
  }
  if (filters.cities.length > 0) {
    query += filters.cities.map(city => `&cities_ids[]=${city}`);
  }
  if (filters.tags.length > 0) {
    query += filters.tags.map(tag => `&tags_ids[]=${tag}`);
  }
  const { status, data } = yield Api.get(`instances/building-products?per_page=50${query}`, false);
  if (status === 200) {
    yield put(fetchProductsSuccessAction(data.data));
  }
}

function* getProduct(action) {
  const { status, data } = yield Api.get(`instances/building-products/${action.payload}`, false);
  if (status === 200) {
    yield put(getProductSuccessAction(data));
  }
}

function* addProduct(action) {
  const { status, data } = yield Api.post('instances/building-products', action.payload, false);
  if (status === 200) {
    yield put(addProductSuccessAction(data));
  }
}

function* deleteProduct(action) {
  const { status } = yield Api.delete(`instances/building-products/${action.payload}`, false);
  if (status === 204) {
    yield put(deleteProductSuccessAction());
  }
}

export default function* productsSagas() {
  yield takeEvery([
    ACT_INSTANCES_FETCH_PRODUCTS_INIT_ACTION,
    ACT_INSTANCES_UPDATE_PRODUCTS_FILTERS,
  ], fetchProducts);
  yield takeEvery(ACT_INSTANCES_GET_PRODUCT_INIT_ACTION, getProduct);
  yield takeEvery(ACT_INSTANCES_ADD_PRODUCT_INIT_ACTION, addProduct);
  yield takeEvery(ACT_INSTANCES_DELETE_PRODUCT_INIT_ACTION, deleteProduct);
}
